// Mirrors iOS CacheManager — a small JSON cache so pages render instantly
// from the last-known data while Firestore refreshes in the background.
// Same 24h TTL iOS uses (CacheManager.maxCacheAge).
const MAX_AGE_MS = 24 * 60 * 60 * 1000;
const PREFIX = 'chef_cache_';

export function loadCache(key) {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (!raw) return null;
    const { data, timestamp } = JSON.parse(raw);
    if (Date.now() - timestamp > MAX_AGE_MS) {
      localStorage.removeItem(PREFIX + key);
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function saveCache(key, data) {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify({ data, timestamp: Date.now() }));
  } catch {}
}

export function clearCache(key) {
  try {
    localStorage.removeItem(PREFIX + key);
  } catch {}
}
